import { Geolocation } from "./localization/geolocation/geolocation";

const showExchangeDisclaimer = (geoLocation: Geolocation): boolean => {
  return geoLocation.defaultCurrency == "CAD";
};

export default showExchangeDisclaimer;
